import React, {Component} from 'react';
import {Card, CardBody} from 'reactstrap';
import {Field} from 'redux-form';
import renderDropZoneField from '../../../../shared/components/form/DropZone';
import {withTranslation} from "react-i18next";

class FeaturedImageCard extends Component {

    render() {

        const {t} = this.props;
        
        return (
            <Card className="card--not-full-height">
                <CardBody>
                    <div className="card__title">
                        <h5 className="bold-text">{t('write.featured_image.title')}</h5>
                        <h5 className="subhead">{t('write.featured_image.subtitle')}</h5>
                    </div>
                    <div className="form__form-group">
                        <div className="form__form-group-field">
                            <Field
                                name="featured_image"
                                component={renderDropZoneField}
                                defaultText={t('write.featured_image.drop_file_here_to_upload')}
                                uploadingText={t('write.featured_image.uploading')}
                                customHeight={true}
                            />
                        </div>
                    </div>
                    <h5 className="subhead">{t('write.featured_image.description')}</h5>

                </CardBody>
            </Card>
        )
    }
}

export default withTranslation('dashboard')(FeaturedImageCard);
